<div class="sidebar-link" *ngIf="visible">
    <a [routerLink]="computedHref" [attr.route]="computedHref" title="{{ text }}">
        {{ text }}
    </a>
</div>